import Vue from 'vue'
import App from './App.vue'
import router from './router'
import rem from './assets/js/rem';
import { Swipe, SwipeItem } from 'vant';
Vue.prototype.rem = rem
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.min.css'
import countTo from 'vue-count-to'
import publicHead from './components/publicHead.vue'
Vue.config.productionTip = false
Vue.use(ElementUI).use(Vant).use(VueAwesomeSwiper)
Vue.component('countTo',countTo)
Vue.component('publicHead',publicHead)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
